export default {
  SYSTEM: 1,
  REQUEST_SENT_TO_CLUB: 2,
  REQUEST_CONFIRMATION_APPROVED: 3,
  REQUEST_CONFIRMATION_DENIED: 4,
  DIGITAL_TICKET_REMINDER: 5,
  GOVERNMENT_USE_NOTICE: 6,
  TODAY_TIX_NOTICE: 7,
  PURCHASE_OPP_SELECTED: 8,
  PURCHASE_OPP_NOT_SELECTED: 9,
  SUITE_REQUEST_APPROVED: 10,
  SUITE_REQUEST_DENIED: 11,
  CHARITY_USE_NOTICE: 12,
  REQUEST_CONFIRMATION_CANCELLED: 13,
  SUITE_REQUEST_CANCELLED: 14,
  USER_INACTIVE: 15,
};
